module.exports = __webpack_public_path__ + "assets/normal/images/slides.32047da2.png";